import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TicketService } from './ticket.service';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { TicketModel } from './ticket.model';

@Component({
    selector: 'convfact-ticketproject',
    templateUrl: './ticket-dialog-project.component.html',
    styleUrls: ['./ticket.component.css'],
    standalone: false
})
export class TicketDialogProjectComponent implements OnInit {
  uid: string;
  ticket: TicketModel;
  projects: MasterModel[] = [];

  request: any = {
    projectUid: null
  };

  errors: string[] = [];
  error = false;
  ready = false;

  constructor(
    public dialogRef: MatDialogRef<TicketDialogProjectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ticketService: TicketService,
    private masterService: MasterService
  ) {
    this.uid = data.uid;
    this.ticket = data.ticket;
  }

   ngOnInit(): void {
  this.loadProjects();

  if (this.ticket && this.ticket.projectUid) {
      this.request.projectUid = this.ticket.projectUid;
    }
}


  loadProjects(): void {
    this.ready = false;
    this.masterService.getProjects().subscribe({
      next: (data) => {
        this.projects = data;
        this.ready = true;
      },
      error: (err) => {
        console.error('Error cargando proyectos:', err);
        this.ready = true;
      }
    });
  }

  save(): void {
    if (!this.request.projectUid) {
      return;
    }

    this.ready = false;

    this.ticketService.loadData(this.uid).then(
      (ticketCompleto) => {
        ticketCompleto.projectUid = this.request.projectUid;

        this.ticketService.editData(this.uid, ticketCompleto).then(
          () => {
            this.ready = true;
            this.dialogRef.close(this.request.projectUid);
          },
          (err) => {
            console.error('Error guardando el proyecto:', err);
            this.error = true;
            this.errors.push('Error al guardar el proyecto');
            this.ready = true;
          }
        );
      },
      (err) => {
        console.error('Error cargando el ticket:', err);
        this.error = true;
        this.errors.push('Error al cargar el ticket');
        this.ready = true;
      }
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
